import { useState, useCallback } from 'react';

export function useSequentialComponents(components) {
    const [index, setIndex] = useState(0);
    const [propsHistory, setPropsHistory] = useState([{}]);

    const next = useCallback((newProps = {}) => {
        setIndex((prev) => {
            const nextIndex = Math.min(prev + 1, components.length - 1);

            setPropsHistory((history) => {
                const newHistory = [...history];
                newHistory[nextIndex] = newProps;
                return newHistory;
            });

            return nextIndex;
        });
    }, [components.length]);

    const previous = useCallback((newProps = {}) => {
        setIndex((prev) => {
            const prevIndex = Math.max(prev - 1, 0);

            setPropsHistory((history) => {
                const newHistory = [...history];
                newHistory[prevIndex] = {
                    ...newHistory[prevIndex],
                    ...newProps,
                };
                return newHistory;
            });

            return prevIndex;
        });
    }, []);

    const CurrentComponent = components[index];
    const currentProps = propsHistory[index] || {};

    return CurrentComponent ? (
        <CurrentComponent {...currentProps} next={next} previous={previous} />
    ) : null;
}